import { render, staticRenderFns } from "./basePagination.vue?vue&type=template&id=1794a95c&scoped=true"
import script from "./basePagination.vue?vue&type=script&lang=js"
export * from "./basePagination.vue?vue&type=script&lang=js"
import style0 from "./basePagination.vue?vue&type=style&index=0&id=1794a95c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794a95c",
  null
  
)

export default component.exports